import axios from "axios";
import { toastr } from "react-redux-toastr";
import { initialize } from "redux-form";
import { toApiUtc } from "../utils/datetime";

// STATES
const INITIAL_VALUES = { name: "", description: "" };
const INITIAL_STATE = {
  list: [],
  show: "list",
  errors: {},
};

// ACTIONS
export function getList(userId, startDate, endDate) {
  const request = axios.get(process.env.REACT_APP_API_HOST+'/crash_logs?search='+(userId ? 'user_id:'+userId+';': '') + toApiUtc(startDate)+';'+toApiUtc(endDate)+'&searchFields=created_at:>;created_at:<&orderBy=id&sortedBy=desc', { silent: true });
  return {
    type: "CRASH_LOGS_FETCHED",
    payload: request,
  };
}

export function create(values, callback = null) {
  return submit(values, "post", callback);
}

function submit(values, method, callback) {
  return (dispatch) => {
    const id = values.id ? values.id + 0 : "";
    let filteredValues = { ...values };
    if (id) delete filteredValues.id;

    axios[method](`${process.env.REACT_APP_API_HOST}/crash_logs${id ? "/" + id : ""}`, filteredValues)
      .then((resp) => {
      })
      .catch((e) => {
        if (!e.response) {
          toastr.error("Erro", "Desconhecido :-/");
          console.log(e);
        } else if (!e.response.data) {
          toastr.error("Erro", e.response.message);
        } else if (e.response.data.errors) {
          Object.entries(e.response.data.errors).forEach(([key, error]) => toastr.error(key, error[0]));
        } else if (e.response.data) {
          toastr.error("Erro", e.response.data.message);
        }
      });
  };
}

export function showContent(flag) {
  return {
    type: "CRASH_LOG_CONTENT_CHANGED",
    payload: flag,
  };
}

// export function showUpdate(crashLog) {
//     return [
//         showContent('form'),
//         initialize('crashLogForm', crashLog)
//     ]
// }

export function init() {
  return [initialize("crashLogForm", INITIAL_VALUES), showContent("list")];
}

// REDUCER
export function crashLogReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case "CRASH_LOGS_FETCHED":
      return { ...state, list: action.payload.data ? action.payload.data.data : [] };

    case "CRASH_LOG_CONTENT_CHANGED":
      return { ...state, show: action.payload };

    default:
      return state;
  }
}
